import { constructs } from "../api/contructs";
import { createSyncedApiHook } from "../api/createSyncedApiHook";
import { createUseItemHook, createUseItemsHook } from "./createUseItemsHook";

const construct = constructs["collection"];

export const useCollection = createUseItemHook(construct);
export const useCollections = createUseItemsHook(construct);
export const useCollectionsApi = createSyncedApiHook(construct);
